import React, { useState } from "react";
import InputOther from "../actions/input-other";
import { InputPhonecountry } from "../actions/input-phone";
import { SendData } from "../api/index.js";
import { useParams } from "react-router-dom";
import validator from "validator";
import pushFormSubmitEvent from "./GTM-function";

type Props = {};

const Form = (props: Props) => {
  const { id } = useParams();
  const formDestination = window.location.href;
    const isProduction = window.location.hostname === "getsak.com";

  const [inputValues, setInputValues] = useState({
    username: "",
    email: "",
  });
  const [phone, setPhone] = useState("");

  const [ErrorInput, setErrorsInput] = useState({
    username: "",
    phone: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false); // default false = الزرار شغال

  const handleOnChange = (event: any) => {
    const { name, value } = event.target;
    const re = /^[0-9\b]+$/;
    if (name === "username") {
      if (re.test(value) === false) {
        setErrorsInput({
          ...ErrorInput,
          username: "",
        });
        setInputValues({ ...inputValues, [name]: value });
      }
    } else {
      setInputValues({ ...inputValues, [name]: value });
    }
  };

  const handleOnChangeEmail = (e: any) => {
    var email = e.target.value;
    if (validator.isEmail(email)) {
      setInputValues({ ...inputValues, email: email });
    }
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (loading) return; // يمنع double submit
    setLoading(true);

    if (inputValues.username === "" || phone === "") {
      setErrorsInput({
        username: inputValues.username === "" ? "يجب ادخال الاسم بالكامل" : "",
        phone: phone === "" ? "يجب ادخال رقم الجوال" : "",
      });
      setLoading(false);
      return;
    } else if (phone.length < 11) {
      setErrorsInput({
        ...ErrorInput,
        phone: "رقم الجوال يجب ان لا يقل عن 9 ارقام",
      });
      setLoading(false);
      return;
    } else if (inputValues.username.length < 3) {
      setErrorsInput({
        ...ErrorInput,
        username: "يرجى كتابه الاسم بالكامل",
      });
      setLoading(false);
      return;
    }

    try {
      // إرسال الداتا للسيرفر
      await SendData(inputValues, phone, id, setErrorMessage, setLoading);

      if (isProduction) {
        await pushFormSubmitEvent({
          id,
          userPhone: `0${phone}`,
          userEmail: inputValues?.email,
          destination: formDestination,
          formLength: 4,
        });
      } else {
        console.log("⚠️ Skipped GTM push in UAT/Staging environment");
      }

    } finally {
      // الزرار يفضل disabled بعد أول submit
      setLoading(true);
    }
  };

  return (
    <form action="" onSubmit={handleSubmit}>
      <div className="from-control">
        <InputOther
          Label="الاسم بالكامل"
          Id="username"
          Type="text"
          Name="username"
          OnChinge={handleOnChange}
          Value={inputValues.username}
          Placeholder="الاسم بالكامل"
          ErrorFild={ErrorInput.username}
        />
        <InputPhonecountry
          Label="رقم الجوال"
          Value={phone}
          SetValue={setPhone}
          Placeholder="523456789"
          ErrorInput={ErrorInput}
          setErrorsInput={setErrorsInput}
        />
        <InputOther
          Label="البريد الالكتروني"
          Id="email"
          Type="email"
          Name="email"
          OnChinge={handleOnChangeEmail}
          Placeholder="example@example.com"
          ErrorFild={""}
        />
      </div>
      {errorMessage !== "" ? (
        <span className="errorfiled">{errorMessage}</span>
      ) : null}

      <button type="submit" className="btn" disabled={loading}>
        <span className="text">
          {loading ? "جارٍ الإرسال..." : "سجل اهتمامك الان"}
        </span>
      </button>
    </form>
  );
};

export default Form;
